export default {"src":"https://fishbrain.com/_next/static/media/virginia.8108fd01.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};